import { SNACKBAR_AUTOHIDE } from './config';

export const snackbarSettings = {
  ITEM_CHANGED_ON_SERVER: {
    autoHideDuration: 3000 + SNACKBAR_AUTOHIDE,
  },
};
